require('./dist/angular-filter.js');
module.exports = 'angular.filter';



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular-filter/index.js
 ** module id = 196
 ** module chunks = 0
 **/